<template>
  <v-layout class="fullSize">
    <loading-page v-if="loading || !settingsLoaded"></loading-page>

    <default-page
        v-else-if="pageIsEmpty"
        imageUrl="/img/dynamic-src-images/price-guard.svg"
        :title="$options.name"
        :text="emptyPageText"
        buttonText="Get Started"
        @button-clicked="
        $router.push({
          path: PGInstancesLength ? '/eventrules' : '/applications',
          query: {
            add: true,
          },
        })
      "
    ></default-page>

    <div v-else class="elevation-1 fullSize fillHeight">
      <confirm-dialog
          :dialog="confirmDialog"
          @confirmation-event="deleteItem($event)"
          @mutate-confirm-dialog="mutateConfirmDialog"
          :text="itemDeletionText"
          :acceptButton="'Delete'"
      ></confirm-dialog>
      <v-row no-gutters class="mx-0">
        <v-col cols="12">
          <v-toolbar height="35" flat color="#2d3436" class="toolbar">
            <v-row class="mx-0" style="max-height: 36px; min-height: 36px">
              <!-- style="margin-bottom: -20px" -->
              <v-col class="pa-0 mt-0" cols="12" md="12" sm="12">
                <v-row class="mx-0">
                  <v-list
                      class="pY-0 sorting-menu"
                      max-height="36px"
                  >
                    <!-- :width="if_smAndDown_else(116, 186)" -->
                    <v-list-item
                        id="sortby-list"
                        @click="() => {}"
                        class="pl-1 pr-1 pl-3"
                        dense
                        max-height="36px"
                    >
                      <!-- :style="`max-width: ${if_smAndDown_else('87', '186')}px;`" -->
                      <v-list-item-content max-height="36px">
                        <v-list-item-title max-height="36px" class="listText">
                          <p
                              class="mb-0"
                              :class="{ 'mr-2': $vuetify.breakpoint.smAndDown }"
                          >
                            {{
                              $vuetify.breakpoint.xsOnly ? "Sort " : "Sort By -"
                            }}

                            {{
                              if_smAndDown_else(
                                  selectedSort.slice(0, 3),
                                  selectedSort
                              )
                            }}
                          </p>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                          v-if="$vuetify.breakpoint.mdAndUp"
                          max-height="36px"
                      >
                        <v-icon
                            :style="
                            $vuetify.theme.dark
                              ? 'color: #47BD96'
                              : 'color: white'
                          "
                        >
                          {{
                            openSortingList
                                ? "keyboard_arrow_up"
                                : "keyboard_arrow_down"
                          }}
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>

                  <v-menu
                      activator="#sortby-list"
                      open-on-click
                      v-model="openSortingList"
                      content-class="sortby-list"
                      offset-y
                  >
                    <v-list class="py-0">
                      <v-list-item
                          class="px-0 sorting-options"
                          v-for="(algorithm, i) in sortingAlgorithms"
                          :key="i"
                          @click="sortByStatus(algorithm.name)"
                          :disabled="i === 2"
                          :aria-disabled="true"
                      >
                        <!-- :style="`max-width: ${if_smAndDown_else(
                          '87',
                          '186'
                        )}px !important;`" -->
                        <v-list-item-title
                            class="listText"
                            :class="{ disabled: i === 2 }"
                        >{{ algorithm.name }}
                        </v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-list
                      v-if="ignoredItems.length > 0"
                      :width="
                      if_smAndDown_else(
                        $vuetify.breakpoint.xsOnly ? 100 : 150,
                        184
                      )
                    "
                      class="py-0 ignored-menu"
                  >
                    <v-list-item
                        id="ignoreditems-list"
                        @click="() => {}"
                        class="ignored-menu-v-list-item pl-3"
                        dense
                    >
                      <!-- :style="`max-width: ${if_smAndDown_else('87', '186')}px;`" -->
                      <v-list-item-content>
                        <v-list-item-title
                            v-if="$vuetify.breakpoint.xsOnly"
                            class="listText"
                        >Ignored Items
                        </v-list-item-title
                        >
                        <v-list-item-title v-else class="listText">
                          Ignored Items :
                          {{ ignoredItems.length }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action v-if="$vuetify.breakpoint.mdAndUp">
                        <v-icon
                            :style="
                            $vuetify.theme.dark
                              ? 'color: #47BD96'
                              : 'color: white'
                          "
                        >
                          {{
                            openIgnoreList
                                ? "keyboard_arrow_up"
                                : "keyboard_arrow_down"
                          }}
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>

                  <!-- :open-on-hover="!isNotDesktop" -->
                  <v-menu
                      activator="#ignoreditems-list"
                      v-if="ignoredItems.length > 0"
                      open-on-click
                      :close-on-content-click="false"
                      v-model="openIgnoreList"
                      offset-y
                  >
                    <v-list
                        class="py-0 overflow-y-auto"
                        max-height="400"
                        :style="` max-width: ${if_smAndDown_else(
                        $vuetify.breakpoint.xsOnly ? '100' : '150',
                        '200'
                      )}px !important;`"
                    >
                      <v-list-item
                          class="ignoredItems"
                          style="
                          padding-right: 4px;
                          padding-left: 4px;
                          overflow: hidden;
                        "
                          v-for="(item, i) in ignoredItems"
                          :key="i"
                      >
                        <v-list-item-content class="pt-1 pb-0">
                          <v-list-item-title class="listText">
                            <div v-if="!if_smAndDown_else()">
                              <v-row class="mx-1">
                                <p
                                    style="font-size: 14px !important"
                                    class="mb-1 mr-3"
                                >
                                  Name:
                                </p>
                                <p
                                    style="font-size: 14px !important"
                                    class="mb-1"
                                >
                                  &nbsp;{{ item.name }}
                                </p>
                              </v-row>
                            </div>
                            <v-row v-else no-gutters class="pb-1">
                              <v-col cols="8">{{ item.name }}</v-col>
                            </v-row>

                            <div v-if="!if_smAndDown_else()">
                              <v-row class="mx-1">
                                <p
                                    style="
                                    font-size: 14px !important;
                                    margin-bottom: -2px;
                                  "
                                    class="mb-1 mr-1"
                                >
                                  Symbol:
                                </p>
                                <p
                                    style="font-size: 14px !important"
                                    class="mb-1"
                                >
                                  {{ item.symbol }}
                                </p>
                              </v-row>
                            </div>
                            <v-row v-else no-gutters>
                              <v-col cols="8">{{ item.symbol }}</v-col>
                            </v-row>
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-icon
                            :class="
                            $vuetify.theme.dark
                              ? if_smAndDown_else(
                                  'removeFromIgnored_mobile removeFromIgnored_dark',
                                  'removeFromIgnored removeFromIgnored_dark'
                                )
                              : if_smAndDown_else(
                                  'removeFromIgnored_mobile removeFromIgnored_light',
                                  'removeFromIgnored removeFromIgnored_light'
                                )
                          "
                            small
                            @click="unignoreItemInList(item, i)"
                        >close
                        </v-icon
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-text-field
                      v-if="$vuetify.breakpoint.smAndUp"
                      id="quick-search"
                      dark
                      :color="$vuetify.theme.dark ? 'primary' : 'secondary'"
                      :style="`${
                      $vuetify.breakpoint.smAndDown
                        ? 'margin-left: 100px;max-width:120px;'
                        : 'margin-right: 10px;max-width:250px;'
                    }`"
                      :value="search"
                      @input="onFilterTextBoxChanged"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                      dense
                      class="pg-search ml-2 mt-1"
                  ></v-text-field>

                  <v-checkbox
                      dark
                      :color="$vuetify.theme.dark ? 'primary' : 'white'"
                      dense
                      height="30"
                      align-self="center"
                      v-model="dataExpiring"
                      off-icon="far fa-square"
                      on-icon="fas fa-check-square"
                      hide-details
                      class="mt-1 ml-2"
                  ></v-checkbox>
                  <p id="expiringof-price" class="mb-0 mt-2 white--text">
                    Expiring
                  </p>
                  <v-tooltip activator="#expiringof-price" bottom>
                    <span
                    >Remove expired data every
                      {{ removeExpiredDataAfter }} second(s)</span
                    >
                  </v-tooltip>

                  <div id="pg-status-info" v-show="$vuetify.breakpoint.mdAndUp">
                    <!-- class="mb-0 ml-8 d-inline-block" -->
                    <p
                        class="mt-2 mb-0 ml-8 d-inline-block status status-info white--text"
                        style="font-size: 14px"
                    >
                      Price Status
                    </p>
                    <v-icon
                        small
                        color="primary"
                        class="d-inline-block pl-2"
                        style="margin-bottom: 2px; font-size: 14px"
                    >
                      far fa-question-circle
                    </v-icon>
                  </div>
                  <v-tooltip
                      color="rgba(19,19,21,1)"
                      activator="#pg-status-info"
                      nudge-top="12"
                      nudge-right="14"
                      bottom
                  >
                    <span>
                      <p class="status new mb-0" style="margin-left: -8px">
                        New (Matched less than a minute ago)
                      </p>
                      <p class="status old mb-0" style="margin-left: -8px">
                        Old (Matched more than a minute ago)
                      </p>
                      <p class="status expired mb-0" style="margin-left: -8px">
                        Expired (Not valid anymore)
                      </p>
                      <p
                          class="status important mb-0"
                          style="margin-left: -8px"
                      >
                        Important
                      </p>
                      <p class="status ignore mb-2" style="margin-left: -8px">
                        Ignored (Is ignored, no notification)
                      </p>
                    </span>
                  </v-tooltip>

                  <v-spacer></v-spacer>

                  <v-btn
                      v-if="$vuetify.breakpoint.smAndUp"
                      text
                      icon
                      small
                      @click="$emit('mute-priceguard')"
                      aria-label="volume"
                      class="mt-1 mx-2"
                  >
                    <!-- class="absolute mt-1" -->
                    <v-icon v-if="priceGuardMute" color="grey"
                    >volume_off
                    </v-icon
                    >
                    <v-icon v-else color="white">volume_up</v-icon>
                  </v-btn>

                  <v-btn
                      v-if="$vuetify.breakpoint.smAndUp"
                      elevation="0"
                      :class="
                      $vuetify.breakpoint.width < 350
                        ? 'clearButtonClass'
                        : 'useLessClass'
                    "
                      :id="
                      $vuetify.breakpoint.width < 350
                        ? 'clearButton'
                        : 'userlessId'
                    "
                      :x-small="$vuetify.breakpoint.width < 350"
                      :small="$vuetify.breakpoint.width >= 350"
                      :width="$vuetify.breakpoint.xsOnly ? '45px' : '85px'"
                      class="btn-clear mr-12"
                      :color="$vuetify.theme.dark ? 'primary' : 'primary'"
                      @click="clearAllMarketData"
                  >Clear
                  </v-btn
                  >
                  <!-- rounded -->
                  <!-- </v-col> -->
                </v-row>
                <v-menu
                    v-model="more_menu"
                    :close-on-content-click="false"
                    v-if="$vuetify.breakpoint.xsOnly"
                    style="display: initial !important"
                    class="borderRad-sm"
                    bottom
                    left
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon text class="white--text more-btn" v-on="on">
                      <span
                          style="
                          font-size: 28px;
                          margin-right: 2px;
                          letter-spacing: 0em !important;
                        "
                          class="icon-more-21x21"
                      >
                        <span class="path1 letterSpacing0"></span>
                        <span class="path2 letterSpacing0"></span>
                        <span class="path3 letterSpacing0"></span>
                        <span class="path4 letterSpacing0"></span>
                      </span>
                    </v-btn>
                  </template>
                  <v-list class="text-center">
                    <v-list-item class="text-center">
                      <v-text-field
                          id="quick-search"
                          dark
                          :color="$vuetify.theme.dark ? 'primary' : 'secondary'"
                          style="margin-right: 10px;max-width:250px;"
                          :value="search"
                          @input="onFilterTextBoxChanged"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                          class="pg-search ml-2 mt-1"
                      ></v-text-field>                      <!-- <v-text-field
                        id="quick-search"
                        color="primary"
                        dense
                        :value="search"
                        @input="onFilterTextBoxChanged"
                        label="Search"
                        width="100"
                        append-icon="search"
                        single-line
                        hide-details
                        style="max-width: 180px"
                      ></v-text-field> -->
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                          class="text-center mx-auto px-2 mt-3"
                          elevation="0"
                          :class="
                          $vuetify.breakpoint.width < 350
                            ? 'clearButtonClass'
                            : 'useLessClass'
                        "
                          :id="
                          $vuetify.breakpoint.width < 350
                            ? 'clearButton'
                            : 'userlessId'
                        "
                          :x-small="$vuetify.breakpoint.width < 350"
                          width="70px"
                          color="primary"
                          @click="
                          clearAllMarketData();
                          more_menu = false;
                        "
                      >Clear
                      </v-btn
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-btn
                          text
                          icon
                          small
                          @click="$emit('mute-priceguard')"
                          aria-label="volume"
                          class="mt-1 mx-2 text-center mx-auto"
                      >
                        <!-- class="absolute mt-1" -->
                        <v-icon v-if="priceGuardMute" color="grey"
                        >volume_off
                        </v-icon
                        >
                        <v-icon v-else :color="$vuetify.theme.dark ? 'white' : 'grey'">volume_up</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col
                  v-if="$vuetify.breakpoint.mdAndUp"
                  :cols="
                  $vuetify.breakpoint.width > 1630
                    ? '1'
                    : $vuetify.breakpoint.smAndDown
                    ? '2'
                    : '2'
                "
              ></v-col>
            </v-row>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-row class="fullSize" no-gutters>
        <v-col>
          <ag-grid-vue
              style="height: 100%; width: 100%"
              class="ag-grid--pg"
              :class="
              $vuetify.theme.dark
                ? 'ag-theme-custom-balham-dark-vue'
                : 'ag-theme-custom-balham-vue'
            "
              :gridOptions="gridOptions"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :masterDetail="true"
              :isRowMaster="isRowMaster"
              :frameworkComponents="frameworkComponents"
              :context="context"
              :postSort="postSort"
              :rowClassRules="rowClassRules"
              :detailCellRendererParams="detailCellRendererParams"
              :detailRowHeight="90"
              :modules="modules"
              :rowData="getPriceGuardEvents"
              :immutableData="true"
              :getRowNodeId="getRowNodeId"
              @grid-ready="onGridReady"
          >
          </ag-grid-vue>
        </v-col>
      </v-row>
    </div>
  </v-layout>
</template>

<script>
import localForage from "localforage";
import TimeAgo from "javascript-time-ago";
// Load locale-specific relative date/time formatting rules.
import en from "javascript-time-ago/locale/en";
import {AgGridVue} from "@ag-grid-community/vue";
import {MasterDetailModule} from "@ag-grid-enterprise/master-detail";
import {ClientSideRowModelModule} from "@ag-grid-community/client-side-row-model";
import {EventRuleService} from "@/services/ApiService";
import {mapMutations, mapGetters, mapActions} from "vuex";
import {
  LoadingPage,
  DefaultPage,
  ConfirmDialog,
} from "../components/Default-Page-Components";
import PriceguardActions from "../components/PriceguardActions";
import PriceguardTimeElapsed from "../components/PriceguardTimeElapsed";
import PriceguardExpiresAt from "../components/PriceguardExpiresAt";
import {EVENT_STATUS, APP_STATE_SECTIONS} from "@/utilities/enums";
import {defaultSettings} from "@/utilities/DefaultObjects";
// import { events } from "../plugins/events";
export default {
  components: {ConfirmDialog, LoadingPage, DefaultPage, AgGridVue},
  name: "PriceGuard",
  data() {
    return {
      settingInitialHeaders: false,
      rowClassRules: null,
      postSort: null,
      context: null,
      frameworkComponents: null,
      isRowMaster: null,
      gridReady: false,
      rowData: null,
      detailCellRendererParams: null,
      defaultColDef: null,
      gridOptions: null,
      columnDefs: null,
      ignoredItems: [],
      more_menu: false,
      itemToDelete: {},
      confirmDialog: false,
      loading: false,
      enabledEventRules: [],
      ignore: false,
      selected: [],
      search: "",
      openIgnoreList: false,
      openSortingList: null,
      selectedSort: "Newest",
      modules: [ClientSideRowModelModule, MasterDetailModule],
      headers: [
        {
          headerName: "Name",
          field: "name",
          cellRenderer: "agGroupCellRenderer",
          cellStyle: {"padding-left": "25px"},
          lockVisible: true,
          sortable: true,
        },
        {
          headerName: "Server",
          field: "serverName",
          cellStyle: {"padding-left": "25px"},
          sortable: true,
          lockVisible: true,
        },
        {
          headerName: "Time Elapsed",
          field: "lastUpdate",
          sortable: true,
          cellRenderer: "priceguardTimeElapsed",
          cellStyle: {"padding-left": "25px"},
          lockVisible: true,
        },
        {
          headerName: "Symbol",
          field: "symbol",
          cellStyle: {"padding-left": "25px"},
          sortable: true,
          lockVisible: true,
        },
        {
          headerName: "Spread",
          field: "spread",
          cellStyle: {"padding-left": "25px"},
          sortable: true,
          lockVisible: true,
        },
        {
          headerName: "Bid",
          field: "bid",
          cellStyle: {"padding-left": "25px"},
          sortable: true,
          lockVisible: true,
        },
        {
          headerName: "Ask",
          field: "ask",
          cellStyle: {"padding-left": "25px"},
          sortable: true,
          lockVisible: true,
        },
        {
          field: "status",
          hide: true,
          comparator: this.tableSort,
          cellStyle: {"padding-left": "25px"},
          lockVisible: true,
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRenderer: "priceguardActions",
          lockVisible: true,
        },
      ],
      sortingAlgorithms: [
        {name: "Newest", func: this.sortNewest},
        {name: "Oldest", func: this.sortOldest},
        {name: "Importance", func: this.sortImportance},
      ],
    };
  },
  created() {
    if (!this.pageReloaded) this.fetchApplicationInstances();

    this.getEventRules();

    // Add locale-specific relative date/time formatting rules.
    TimeAgo.addLocale(en);
    // Create relative date/time formatter.
    this.timeAgo = new TimeAgo("en-US");
  },
  beforeMount() {
    this.gridOptions = {};

    this.defaultColDef = {
      flex: 1,
      width: 100,
      sortable: true,
      resizable: true,
    };
    this.context = {componentParent: this};

    this.rowClassRules = rowClassRulesHelper;

    this.postSort = (rowNodes) => {
      if (this.selectedSort === "Oldest" || this.selectedSort === "Importance") {
        let ignoredItemsIDs = rowNodes.reduce((final, next) => {
          if (next.data.status === EVENT_STATUS.IGNORE) final.push(next.id);
          return final;
        }, []);
        ignoredItemsIDs.forEach((ignoredId) => {
          let index = rowNodes.findIndex((node) => node.id === ignoredId);
          rowNodes.splice(rowNodes.length - 1, 0, rowNodes.splice(index, 1)[0]);
        });
      }
    };

    let allheaders = [
      {
        headerName: "Name",
        field: "name",
        cellRenderer: "agGroupCellRenderer",
        cellStyle: {"padding-left": "25px"},
        lockVisible: true,
        sortable: true,
      },
      {
        headerName: "Server",
        field: "serverName",
        cellStyle: {"padding-left": "25px"},
        sortable: true,
        lockVisible: true,
      },
      {
        headerName: "Time Elapsed",
        field: "timestamp",
        sortable: true,
        cellRenderer: "priceguardTimeElapsed",
        cellStyle: {"padding-left": "25px"},
        lockVisible: true,
      },
      {
        headerName: "Symbol",
        field: "symbol",
        cellStyle: {"padding-left": "25px"},
        sortable: true,
        lockVisible: true,
      },
      {
        headerName: "Spread",
        field: "spread",
        cellStyle: {"padding-left": "25px"},
        sortable: true,
        lockVisible: true,
      },
      {
        headerName: "Bid",
        field: "bid",
        cellStyle: {"padding-left": "25px"},
        sortable: true,
        lockVisible: true,
      },
      {
        headerName: "Ask",
        field: "ask",
        cellStyle: {"padding-left": "25px"},
        sortable: true,
        lockVisible: true,
      },
      {
        field: "status",
        hide: true,
        comparator: this.tableSort,
        cellStyle: {"padding-left": "25px"},
        lockVisible: true,
      },
      {
        headerName: "Actions (Delete/Ignore)",
        field: "actions",
        cellRenderer: "priceguardActions",
        lockVisible: true,
      },
    ];

    if (this.isAdmin) {
      let expiresAt = {
        headerName: "Expires In",
        field: "expiresAt",
        cellRenderer: "PriceguardExpiresAt",
        cellStyle: {"padding-left": "25px"},
        sortable: true,
        lockVisible: true,
      };
      allheaders.splice(8, 0, expiresAt);

      this.settingInitialHeaders = true;
      this.headers.splice(8, 0, expiresAt);
    }

    this.isRowMaster = (dataItem) => {
      return dataItem ? this.headersCounter < 10 : false;
    };

    let position = this.headersCounter - 1;
    let itemsToRemove = this.headers.length - this.headersCounter;
    allheaders.splice(position, itemsToRemove);

    if (
        allheaders.length &&
        allheaders[0].hasOwnProperty("cellRenderer") &&
        allheaders.length === this.headers.length
    ) {
      // hide expand button
      delete allheaders[0].cellRenderer;
    }

    this.columnDefs = allheaders;

    this.frameworkComponents = {
      priceguardActions: PriceguardActions,
      priceguardTimeElapsed: PriceguardTimeElapsed,
      PriceguardExpiresAt,
    };

    this.detailCellRendererParams = {
      refreshStrategy: "rows",
      detailGridOptions: {
        columnDefs: [{field: "header"}, {field: "value"}],
        defaultColDef: {flex: 1},
        headerHeight: 0,
      },
      getDetailRowData: (params) => {
        let expandItems = [];
        let expandItemsLength = this.headers.length - this.headersCounter;
        let newExpandedItemsLength =
            this.headersCounter === 2 ? expandItemsLength : expandItemsLength + 1;
        for (let i = 1; i < newExpandedItemsLength; i++) {
          let headerObj = this.headers[this.headers.length - 1 - i];
          let newItem = {header: headerObj.headerName, value: null};

          switch (headerObj.field) {
            case "lastUpdate":
              newItem.value = this.calculateTime(params.data["timestamp"]);
              break;
            case "expiresAt":
              newItem.value = this.calculateTime(
                  this.currentEpochTime + params.data["expiresAt"] * 1000
              );
              break;
            default:
              newItem.value = params.data[headerObj.field];
          }
          expandItems.unshift(newItem);
        }
        if (this.headersCounter < 10) {
          params.successCallback(expandItems);
        } else {
          params.successCallback([]);
        }
      },
    };
  },
  mounted() {
    // if(this.settingsLoaded)
    //   this.setIgnoredItems()
    // localForage.getItem("PGignoredItems", (err, value) => {
    //   if (value != null) this.ignoredItems = value;
    // });
  },
  props: {
    settingsLoaded: {
      type: Boolean,
      default: false,
    },
    priceguarDataExpiring: {
      type: Boolean,
      default: false,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeX: {
      type: Number,
      default: 0,
    },
    pageReloaded: {
      type: Boolean,
      default: false,
    },
    currentEpochTime: {
      type: Number,
      default: 0,
    },
    removeExpiredDataAfter: {
      type: Number,
      default: 3,
    },
    priceGuardMute: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataExpiring: {
      get() {
        return this.priceguarDataExpiring;
      },
      set(v) {
        this.$emit("set-priceguard-expiring", v);
      },
    },
    priceOldAfter() {
      if (
          this.getSettings === undefined ||
          !Object.keys(this.getSettings).length
      )
        return defaultSettings.applications.priceguard.priceOldAfter;
      else return this.getSettings.applications.priceguard.priceOldAfter;
    },
    dataExpirationCycle() {
      if (
          this.getSettings === undefined ||
          !Object.keys(this.getSettings).length
      ) {
        return defaultSettings.applications.priceguard.dataExpirationCycle;
      } else {
        return this.getSettings.applications.priceguard.dataExpirationCycle;
      }
    },
    emptyPageText() {
      return !this.PGInstancesLength
          ? "It seems that you don't have any price guard application instances running. Click Get Started below to add Applications"
          : "It seems that you don't have any event rules enabled. Click Get Started below to open Event Rules page";
    },
    pageIsEmpty() {
      return this.PGInstancesLength === 0 || this.enabledEventRules.length === 0;
    },
    itemDeletionText() {
      return Object.keys(this.itemToDelete).length
          ? `Delete symbol ${this.itemToDelete.symbol} ?`
          : "";
    },
    headersCounter() {
      switch (true) {
        case this.windowSizeX < 456:
        case this.windowSizeX < 670:
          // return this.headers.length - 7;
        case this.windowSizeX < 800:
          return this.headers.length - 6;
        case this.windowSizeX < 1100:
          return this.headers.length - 4;
        default:
          return this.headers.length;
      }
    },
    PGInstancesLength: function () {
      if (!this.isNotDesktop && this.getApplicationInstances.length) {
        document.getElementById("htmlId").style.overflowY = "hidden";
      } else {
        document.getElementById("htmlId").style.overflowY = "auto";
      }
      return this.getApplicationInstances.length;
    },
    ...mapGetters(["getPriceGuardEvents"]),
    ...mapGetters("instances", ["getApplicationInstances"]),
    ...mapGetters(["isAdmin"]),
    ...mapGetters(["getSettings"]),
  },

  methods: {
    setIgnoredItems(items) {
      this.ignoredItems = items;
    },
    applySort(name) {
      this.selectedSort = name;
      // refreshClientSideRowModel re-executes (grouping,sorting,filtering)
      if (this.gridOptions && this.gridOptions.api)
        this.gridOptions.api.refreshClientSideRowModel();
      else if (this.isAdmin) {
        console.error();
        ("Something went wrong when applying sorting.");
      }
    },
    saveIgnoredItems() {
      let options = {
        section: APP_STATE_SECTIONS.PRICEGUARD,
        innerSection: "ignoredItems",
        mutation: JSON.parse(JSON.stringify(this.ignoredItems)),
      };
      this.$emit("update-app-state", options);
    },
    sortByStatus(name) {
      this.applySort(name);

      let options = {
        section: APP_STATE_SECTIONS.PRICEGUARD,
        innerSection: "sort",
        mutation: this.selectedSort,
      };
      this.$emit("update-app-state", options);
    },
    calculateTime: function (date, justNowText) {
      let soonText = justNowText ? justNowText : "just now";
      let elapsedTime = this.timeAgo.format(date, "twitter");
      if (elapsedTime.length < 4 && elapsedTime.includes("s")) {
        return soonText;
      } else {
        return elapsedTime;
      }
    },
    onFilterTextBoxChanged() {
      this.gridOptions.api.setQuickFilter(
          document.getElementById("quick-search").value
      );
    },
    tableSort(val1, val2, node1, node2) {
      let status1 = val1;
      let status2 = val2;
      if (status1 === null && status2 === null) {
        return 0;
      }
      if (status1 === null) {
        return -1;
      }
      if (status2 === null) {
        return 1;
      }
      if (this.selectedSort === "Newest") {
        return val1 - val2;
      }
      if (this.selectedSort === "Oldest") {
        return val2 - val1;
      }
    },
    getRowNodeId(data) {
      return data.id;
    },
    onGridReady() {
      if (!this.gridReady) this.gridReady = true;

      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: "status",
            sort: "asc",
          },
        ],
        defaultState: {sort: null},
      });

      if (this.settingsLoaded) {
        let settings = JSON.parse(JSON.stringify(this.getSettings));
        let sort = settings.applicationState.priceguard.sort;
        this.applySort(sort);
        this.setIgnoredItems(settings.applicationState.priceguard.ignoredItems);
      }
    },
    unignoreItemInList(item, indexOfItem) {
      this.removeFromIgnoredList(indexOfItem);
      // Make sure the status is correct
      if (item.status === EVENT_STATUS.IGNORE) {
        // Deed the updated price since "item" might have outdated data
        let price = this.getPriceGuardEvents.find((el) => el.id === item.id);
        if (price) {
          this.unIgnorePrice({
            id: price.id,
            status: price.status,
            client_timestamp: price.client_timestamp,
            lastUpdate: price.lastUpdate,
          });
        } else {
          this.$notifier.error("Oops! Something went wrong..");
        }
      }
    },
    ignoreBtnClick(item) {
      let indexOfItem;
      let unIgnoreItem = this.ignoredItems.some((el, index) => {
        if (el.id === item.id) {
          indexOfItem = index;
          return true;
        } else return false;
      });
      if (unIgnoreItem) {
        this.removeFromIgnoredList(indexOfItem);
        // Make sure the status is correct
        if (item.status === EVENT_STATUS.IGNORE) {
          this.unIgnorePrice(item);
        }
      } else {
        // Add the price to ignored list
        this.ignoredItems.push({
          name: item.name,
          symbol: item.symbol,
          id: item.id,
          priority: item.priority,
          status: EVENT_STATUS.IGNORE,
          client_timestamp: item.client_timestamp,
          lastUpdate: item.lastUpdate,
          timestamp: item.timestamp,
        });

        this.ignorePrice(item);
      }
      this.saveIgnoredItems();
    },
    mutateConfirmDialog(value) {
      this.confirmDialog = value;
    },
    if_smAndDown_else(ifTrue = true, ifFalse = false) {
      // This function is use to quickly return the right parameter given
      // depending on screen width. With no parameters it returns wether screen is smAndDown
      if (this.$vuetify.breakpoint.smAndDown) return ifTrue;
      else return ifFalse;
    },
    getEventRules() {
      this.loading = true;
      let params = {
        page: 0,
        size: 9999,
      };
      EventRuleService.query({params: params})
          .then((response) => {
            this.enabledEventRules = response.data.content.filter(
                (el) => el.enabled === true
            );
            this.loading = false;
          })
          .catch((err) => {
            console.error(err);
            this.$notifier.warn("An error occurred while fetching event rules");
            this.loading = false;
          });
    },
    changeStatus(item) {
      let modifiedStatus = null;
      switch (item.status) {
        case EVENT_STATUS.NEW:
          modifiedStatus = EVENT_STATUS.IGNORE;
          break;
        case EVENT_STATUS.IGNORE:
          var timePassedSinceCame = Math.trunc(
              (Date.now() - item.lastUpdate) / 1000
          );
          if (timePassedSinceCame > 60) modifiedStatus = EVENT_STATUS.OLD;
          else modifiedStatus = EVENT_STATUS.NEW;
          break;
        case EVENT_STATUS.IMPORTANT:
        case EVENT_STATUS.OLD:
        case EVENT_STATUS.EXPIRED:
          modifiedStatus = EVENT_STATUS.IGNORE;
          break;
      }
      this.changeItemStatus({itemToChange: item, newStatus: modifiedStatus});
    },
    removeFromIgnoredList(indexOfItem) {
      this.ignoredItems.splice(indexOfItem, 1);
      this.saveIgnoredItems();
    },
    priceIsExpired(item) {
      let lastReceived = Date.now() - item.client_timestamp;
      return lastReceived >= this.dataExpirationCycle * 1000;
    },
    unIgnorePrice(item) {
      let modifiedStatus = null;
      let expired = this.priceIsExpired(item);
      var timePassed = Math.trunc((Date.now() - item.lastUpdate) / 1000);
      if (expired) modifiedStatus = EVENT_STATUS.EXPIRED;
      else if (timePassed < this.priceOldAfter)
        modifiedStatus = EVENT_STATUS.NEW;
      else modifiedStatus = EVENT_STATUS.OLD;

      this.changeItemStatus({itemToChange: item, newStatus: modifiedStatus});
    },
    ignorePrice(item) {
      this.changeItemStatus({
        itemToChange: item,
        newStatus: EVENT_STATUS.IGNORE,
      });
    },
    confirmationDialog(item) {
      this.itemToDelete = item;
      this.confirmDialog = !this.confirmDialog;
    },
    deleteItem(confirm) {
      if (confirm) {
        this.deleteItemFromMarketData(this.itemToDelete);
      }
      this.confirmDialog = !this.confirmDialog;
    },
    clearAllMarketData() {
      this.clearMarketData();
    },
    ...mapMutations(["clearMarketData"]),
    ...mapMutations(["deleteItemFromMarketData"]),
    ...mapMutations(["changeItemStatus"]),
    ...mapActions("instances", ["fetchApplicationInstances"]),
  },

  watch: {
    settingsLoaded(v) {
      if (v) {
        try {
          let settings = JSON.parse(JSON.stringify(this.getSettings));
          let sort = settings.applicationState.priceguard.sort;
          this.applySort(sort);
          this.setIgnoredItems(
              settings.applicationState.priceguard.ignoredItems
          );

          this.ignoredItems = JSON.parse(
              JSON.stringify(settings.applicationState.priceguard.ignoredItems)
          );
        } catch (error) {
          if (this.isAdmin)
            console.error("Something went wrong when applying saved sorting.");
          console.error(error);
        }
      }
    },
    // DESCRIPTION: On headersCounter change -> change the columnDefs & reset data to hide or show expand button
    headersCounter(val) {
      if (this.settingInitialHeaders) {
        this.settingInitialHeaders = false;
        return;
      }
      let oldColumns = this.gridOptions.api.getColumnDefs();
      let newColumns = this.headers.reduce((final, next, i) => {
        if (i < val - 1) {
          final.push(JSON.parse(JSON.stringify(next))); // clean no-reference objects
        }
        return final;
      }, []);

      newColumns.push({
        headerName: "Actions", // always add actions as last column (for better UX)
        field: "actions",
        cellRenderer: "priceguardActions",
      });

      if (
          newColumns[0].hasOwnProperty("cellRenderer") &&
          newColumns.length &&
          newColumns.length === this.headers.length
      ) {
        // hide expand button if all columns are visible but the button isn't hidden
        delete newColumns[0].cellRenderer;
      }

      this.gridOptions.api.setColumnDefs(newColumns); // update columnDefs

      let columnsState = this.gridOptions.columnApi.getColumnState(); // add actions to the end of the table

      if (columnsState[columnsState.length - 1].colId !== "actions") {
        // if actions is not at the end, move it there
        let old_index;
        columnsState.some((el, i) => {
          if (el.colId === "actions") {
            old_index = i;
            return true;
          } else return false;
        });

        columnsState.splice(
            columnsState.length,
            0,
            columnsState.splice(old_index, 1)[0]
        ); // move the "actions" column to the end
        this.gridOptions.columnApi.applyColumnState({
          state: columnsState,
          applyOrder: true,
        }); // apply columnsState
      }

      if (oldColumns[0].cellRenderer !== newColumns[0].cellRenderer || val < 9) {
        let arr = this.getPriceGuardEvents.map((el) =>
            JSON.parse(JSON.stringify(el))
        );
        this.gridOptions.api.redrawRows();
        this.gridOptions.api.setRowData(arr);
      }
    },
    ignoredItems(val) {
      this.$emit("ignored-pg-prices-change", val);
      if (!val.length) {
        this.openIgnoreList = false;
      }
    },
  },
};

let rowClassRulesHelper = {
  // detail property means its a 'detail' row (i.e expand row on mobile screens) which can't have status class
  status: (params) => !params.node.detail,
  new: (params) => {
    return !params.node.detail && params.data.status === EVENT_STATUS.NEW;
  },
  important: (params) => {
    return !params.node.detail && params.data.status === EVENT_STATUS.IMPORTANT;
  },
  old: (params) => {
    return !params.node.detail && params.data.status === EVENT_STATUS.OLD;
  },
  expired: (params) => {
    return !params.node.detail && params.data.status === EVENT_STATUS.EXPIRED;
  },
  ignore: (params) => {
    return !params.node.detail && params.data.status === EVENT_STATUS.IGNORE;
  },
};
</script>

<style lang="scss">
//  Use css variables to customize ag-grid theme
.ag-theme-balham-dark {
  --ag-control-panel-background-color: #1c6e59 !important;
}

.ag-theme-balham {
  --ag-control-panel-background-color: #1c6e59 !important;
}

//
.ag-column-drop-wrapper .ag-column-drop-horizontal {
  border-bottom: none !important;
}

@import "../../node_modules/@ag-grid-community/core/dist/styles/ag-grid.css";
@import "../../node_modules/@ag-grid-community/core/dist/styles/ag-theme-balham/sass/ag-theme-balham-mixin.scss";
@import "../../node_modules/@ag-grid-community/core/dist/styles/ag-theme-balham-dark/sass/ag-theme-balham-dark-mixin.scss";

.ag-theme-custom-balham-vue {
  @include ag-theme-balham(
          (
              header-cell-moving-background-color: #47bd96,
              header-background-color: #001C27,
              odd-row-background-color: #f5f5f5,
              control-panel-background-color: #1c6e59,
              hover-color: #d8d8db,
              chip-background-color: #47bd96,
              primary-color: #47bd96,
              disabled-foreground-color: rgba(245, 245, 245, 0.38),
              secondary-foreground-color: rgba(245, 245, 245, 1),
          )
  );

  .ag-menu-option-active {
    background-color: #2661ad;
    color: white;
  }
}

.ag-theme-custom-balham-dark-vue {
  @include ag-theme-balham-dark(
          (
              header-cell-moving-background-color: #47bd96,
              header-background-color: #001C27,
              control-panel-background-color: #001C27,
              chip-background-color: #47bd96,
              primary-color: #47bd96,
          )
  );

  .ag-menu-option-active {
    background-color: #2661ad;
    color: white;
  }
}
</style>

<style src="../css/utilities/priceGuard.css"></style>
<style scoped src="../css/utilities/scoped/priceGuard.css"></style>
